module.exports = __webpack_public_path__ + "img/image37.d95623b8.png";